export const EV_ADD_TO_CART = 'EV_ADD_TO_CART';
export const EV_CART_VIEW = 'EV_CART_VIEW';
export const EV_CHECKOUT_OPTION = 'EV_CHECKOUT_OPTION';
export const EV_CHECKOUT_VIEW = 'EV_CHECKOUT_VIEW';
export const EV_GENERIC = 'EV_GENERIC';
export const EV_PAGE_VIEW = 'EV_PAGE_VIEW';
export const EV_PRODUCT_VIEW = 'EV_PRODUCT_VIEW';
export const EV_PURCHASE = 'EV_PURCHASE';
export const EV_REMOVE_FROM_CART = 'EV_REMOVE_FROM_CART';
export const EV_BODY_SCROLL = 'EV_BODY_SCROLL';
export const EV_SEARCH = 'EV_SEARCH';
export const EV_SEARCH_NO_HITS = 'EV_SEARCH_NO_HITS';
export const EV_SEARCH_NO_SUGGESTIONS = 'EV_SEARCH_NO_SUGGESTIONS';
export const EV_SEARCH_ON_SUGGESTION_CLICK = 'EV_SEARCH_ON_SUGGESTION_CLICK';
export const EV_BEGIN_PAYMENT = 'EV_BEGIN_PAYMENT';
export const EV_PAYMENT_ABORTED = 'EV_PAYMENT_ABORTED';
export const EV_BEGIN_PAYMENT_FAILED = 'EV_BEGIN_PAYMENT_FAILED';
export const EV_PAYMENT_BROWSER_BACK = 'EV_PAYMENT_BROWSER_BACK';
export const EV_PRODUCT_IMPRESSION = 'EV_PRODUCT_IMPRESSION';
export const EV_PRODUCT_CLICK = 'EV_PRODUCT_CLICK';
export const EV_UPDATE_POSTAL = 'EV_UPDATE_POSTAL';
export const EV_BLOCK_IMPRESSION = 'EV_BLOCK_IMPRESSION';
export const EV_BLOCK_CLICKED = 'EV_BLOCK_CLICKED';
export const EV_ALERTBANNER_CLICKED = 'EV_ALERTBANNER_CLICKED';
